import React, { useState, useEffect, useRef } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import styled from 'styled-components'
import { css } from '@emotion/core'
import { BeatLoader } from 'react-spinners'
import moment from 'moment'
import orderBy from 'lodash/orderBy'

import withLayout from '../../helpers/withLayout'
import { SimpleModal } from '../../components/modal/simple-modal'
import { modalButtons } from '../../components/buttons/modal-button'
import { filterMovement, filterPersonal, filterRole } from '../../components/new-employee/schema'
import Manual from '../../components/new-employee/manual'

import {
  ActionBar,
  DataTable,
  EditPane,
  CreateForm,
} from '../../components/new-employee'
import {
  authAction,
  masterDataAction,
  employeeAction,
} from '../../actions'
import {
  authSelector,
  masterDataSelector,
  employeeSelector,
} from '../../selectors'

const UserPage = () => {
  const access_token = localStorage.getItem('access_token')
  const dispatch = useDispatch()
  const [isCreate, setIsCreate] = useState(false)
  const [activeItem, setActiveItem] = useState(null)
  const [openDetail, setOpenDetail] = useState(false)
  const [employeeList, setEmployeeList] = useState([])
  const [_companys, setCompanys] = useState([])
  const [_lobs, setLobs] = useState([])
  const [_departments, setDepartments] = useState([])
  const [_positions, setPositions] = useState([])
  const [_divisions, setDivisions] = useState([])
  const [_teams, setTeams] = useState([])
  const [emp, setEmp] = useState({})
  const [movementData, setMovementData] = useState({})
  const [movements, setMovements] = useState([])
  const childEditPane = useRef()

  const masterDataState = useSelector(masterDataSelector.getGetMasterData)
  const employeeListState = useSelector(employeeSelector.getListUser)
  const employeeState = useSelector(employeeSelector.getEmployee)
  const isEditPersonal = employeeState.isEditPersonal
  const isEditCompany = employeeState.isEditCompany
  const isEditRole = employeeState.isEditRole
  const isEditMovement = employeeState.isEditMovement
  const responseModal = employeeState.responseModal

  const authData = useSelector(authSelector.getAuth)
  const redirectAuth = useSelector(authSelector.redirectAuth)
  const isFetchingMasterData = useSelector(masterDataSelector.getIsFetching)
  const isFetchingEmployee = useSelector(employeeSelector.getIsFetching)
  const isFetching = isFetchingMasterData || isFetchingEmployee

  const isOpenManual = useSelector(employeeSelector.isOpenManual)

  const createdState = useSelector(employeeSelector.getCreateUserData)
  const createdMovementState = useSelector(employeeSelector.getCreateMovementData)
  const editedMovementState = useSelector(employeeSelector.getEditMovementData)
  const deletedMovementState = useSelector(employeeSelector.getDeleteMovementData)
  const editedPrivilegeState = useSelector(employeeSelector.getEditPrivilegeData)
  const updatedState = useSelector(employeeSelector.getEditUserData)
  const deletedState = useSelector(employeeSelector.getDeactivateUserData)
  const importState = useSelector(employeeSelector.getImportResult)

  useEffect(() => {
    fetchData()
    return () => {
      Promise.all([
        dispatch(employeeAction.setEditPersonal({ isEditPersonal: false })),
        dispatch(employeeAction.setEditCompany({ isEditCompany: false })),
        dispatch(employeeAction.setEditRole({ isEditRole: false })),
        dispatch(employeeAction.setEditMovement({ isEditMovement: false })),
        dispatch(employeeAction.setKeywordSearch({ keywordSearch: '' })),
      ])
    }
  }, [])

  useEffect(() => {
    if (employeeListState && masterDataState.masterData) {
      const masterData = masterDataState.masterData
      const { companys, lobs, positions, departments, divisions, teams } = masterData
      const employees = []
      employeeListState.map(e => {
        const company = masterData.companys.find(l => l._id === e.company_id)
        const lob = masterData.lobs.find(l => l._id === e.lob_id)
        const position = masterData.positions.find(l => l._id === e.position_id)
        employees.push({
          ...e,
          label: `${e.emp_code} - ${e.first_name} ${e.last_name}`,
          value: e._id,
          company: company ? company.name : '-',
          lob: lob ? lob.name : '-',
          position: position ? position.name : '-',
          name: `${e.first_name} ${e.last_name}`,
        })
        return e
      })
      const tcompanys = []
      const tlobs = []
      const tdepartments = []
      const tdivisions = []
      const tteams = []
      const tpositions = []
      companys.map(c => {
        if (c.is_active) tcompanys.push({ ...c, label: c.name, value: c._id })
        return c
      })
      lobs.map(l => {
        if (l.is_active) tlobs.push({ ...l, label: l.name, value: l._id })
        return l
      })
      departments.map(d => {
        if (d.is_active) tdepartments.push({ ...d, label: d.name, value: d._id })
        return d
      })
      divisions.map(d => {
        if (d.is_active) tdivisions.push({ ...d, label: d.name, value: d._id })
        return d
      })
      teams.map(t => {
        if (t.is_active) tteams.push({ label: t.name, value: t._id })
        return t
      })
      positions.map(p => {
        if (p.is_active) tpositions.push({ ...p, label: p.name, value: p._id })
        return p
      })
      setCompanys([...tcompanys])
      setLobs([...tlobs])
      setDepartments([...tdepartments])
      setPositions([...tpositions])
      setDivisions([...tdivisions])
      setTeams([...tteams])
      setEmployeeList(employees)
    }
  }, [employeeListState, masterDataState])

  useEffect(() => {
    let response = {}
    let actions = {}
    if (createdState && createdState.status) response = createdState
    if (createdMovementState && createdMovementState.status) response = createdMovementState
    if (editedPrivilegeState && editedPrivilegeState.status) response = editedPrivilegeState
    if (editedMovementState && editedMovementState.status) response = editedMovementState
    if (deletedMovementState && deletedMovementState.status) response = deletedMovementState
    else if (updatedState && updatedState.status) response = updatedState
    else if (deletedState && deletedState.status) response = deletedState
    else if (importState && importState.status) response = importState

    if (response.status) {
      switch (response.type) {
        case 'error':
        case 'success': {
          actions = { close: closeResponseModal }
          break
        }
        default: break
      }

      dispatch(employeeAction.openResponseModal({
        responseModal: {
          isOpen: true,
          res: {
            type: response.type,
            title: response.status,
            description: response.message,
            actions: modalButtons(response.type, actions),
          },
        },
      }))
      resetState()
    }
  }, [
    createdState.status,
    updatedState.status,
    deletedState.status,
    createdMovementState.status,
    editedPrivilegeState.status,
    editedMovementState.status,
    deletedMovementState.status,
    importState.status,
  ])

  useEffect(() => {
    if (redirectAuth) {
      const isAuthenticated = redirectAuth.isAuthenticated
      const redirect = redirectAuth.redirect
      if (redirect) {
        localStorage.clear()
        if (isAuthenticated) localStorage.setItem('bad_token', true)
        dispatch(authAction.resetAuth())
        window.location = '/'
      }
    }
    if (authData && authData.user) {
      const isSystemAdmin = authData.user.is_system_admin
      const isHRAdminRole = authData.user.is_hr_admin_role
      const isHRConfidentialRole = authData.user.is_hr_admin_confidential_role
      const isManagementRole = authData.user.is_management_role
      if (!(isSystemAdmin || isHRAdminRole || isHRConfidentialRole || isManagementRole)) window.location = '/home'
    }
  }, [authData, redirectAuth])

  const fetchData = async () => {
    await dispatch(authAction.auth(access_token))
    await Promise.all([
      dispatch(masterDataAction.getMasterData(access_token)),
      dispatch(employeeAction.getUser(access_token)),
    ])
  }

  const getEmpDataByID = async (id, movement_id, isReset = false) => {
    const res = await dispatch(employeeAction.getUserByID(id, access_token))
    if (res.payload) {
      let movementId
      let currMovement
      const userData = res.payload.findedUser
      if (isReset) {
        currMovement = userData ? userData.movements
          .find(m => moment(m.start_date)
            .isSame(userData.start_date)) : {}
      } else {
        if (movement_id) movementId = movement_id
        else movementId = movementData ? movementData._id : ''
        currMovement = userData.movements.find(m => m._id === movementId)
      }
      setEmp(userData)
      setMovements(orderBy(userData.movements, 'start_date', 'desc'))
      setMovementData(currMovement)
    }
  }

  const resetState = async () => {
    await Promise.all([
      dispatch(employeeAction.resetCreateUser()),
      dispatch(employeeAction.resetEditUser()),
      dispatch(employeeAction.resetDeactivateUser()),
      dispatch(employeeAction.resetImportUser()),
      dispatch(employeeAction.resetExportUser()),
      dispatch(employeeAction.resetCreateMovement()),
      dispatch(employeeAction.resetEditMovement()),
      dispatch(employeeAction.resetEditPrivilege()),
      dispatch(employeeAction.resetDeleteMovement()),
    ])
  }

  const resetEditState = () => {
    childEditPane.current.resetEditState()
    setOpenDetail(false)
    setActiveItem(null)
  }

  const closeResponseModal = () => {
    dispatch(employeeAction.openResponseModal({ responseModal: { isOpen: false, res: {} } }))
  }

  const handleClickRow = async id => {
    if (isEditPersonal || isEditCompany || isEditRole || isEditMovement) {
      const actions = {
        cancel: closeResponseModal,
        discard: () => {
          Promise.all([
            dispatch(employeeAction.setEditPersonal({ isEditPersonal: false })),
            dispatch(employeeAction.setEditCompany({ isEditCompany: false })),
            dispatch(employeeAction.setEditRole({ isEditRole: false })),
            dispatch(employeeAction.setEditMovement({ isEditMovement: false })),
          ])
          childEditPane.current.setDefaultTab()
          childEditPane.current.resetInvalidList()
          getEmpDataByID(id, null, true)
          setActiveItem(id)
          closeResponseModal()
        },
      }
      openDiscardModal(actions)
    } else {
      await getEmpDataByID(id, null, true)
      childEditPane.current.setDefaultTab()
      setOpenDetail(true)
      setActiveItem(id)
    }
  }

  const handleClickEditTab = setActiveTab => {
    if (isEditPersonal || isEditCompany || isEditRole || isEditMovement) {
      const actions = {
        cancel: closeResponseModal,
        discard: () => {
          Promise.all([
            dispatch(employeeAction.setEditPersonal({ isEditPersonal: false })),
            dispatch(employeeAction.setEditCompany({ isEditCompany: false })),
            dispatch(employeeAction.setEditRole({ isEditRole: false })),
            dispatch(employeeAction.setEditMovement({ isEditMovement: false })),
          ])
          getEmpDataByID(emp._id)
          setActiveTab()
          closeResponseModal()
        },
      }
      openDiscardModal(actions)
    } else {
      setActiveTab()
    }
  }

  const handleClickClose = () => {
    if (isEditPersonal || isEditCompany || isEditMovement || isEditRole) {
      const actions = {
        cancel: closeResponseModal,
        discard: () => {
          childEditPane.current.resetInvalidList()
          resetEditState()
          closeResponseModal()
        },
      }
      openDiscardModal(actions)
    } else {
      resetEditState()
    }
  }

  const handleClickCancel = id => {
    const actions = {
      cancel: closeResponseModal,
      discard: () => {
        Promise.all([
          dispatch(employeeAction.setEditPersonal({ isEditPersonal: false })),
          dispatch(employeeAction.setEditCompany({ isEditCompany: false })),
          dispatch(employeeAction.setEditRole({ isEditRole: false })),
          dispatch(employeeAction.setEditMovement({ isEditMovement: false })),
        ])
        childEditPane.current.resetInvalidList()
        getEmpDataByID(id)
        closeResponseModal()
      },
    }
    openDiscardModal(actions)
  }

  const openDiscardModal = actions => {
    dispatch(employeeAction.openResponseModal({
      responseModal: {
        isOpen: true,
        res: {
          title: 'Unsaved changes',
          description: 'Are you sure you want to discard these changes?',
          actions: modalButtons('discard', actions),
        },
      },
    }))
  }

  const handleUploadImage = async res => {
    const actions = { close: closeResponseModal }
    await dispatch(employeeAction.openResponseModal({
      responseModal: {
        isOpen: true,
        res: {
          title: 'Uploaded Successfully',
          description: 'Your image had been uploaded',
          actions: modalButtons('success', actions),
        },
      },
    }))
    childEditPane.current.closeUploadModal()
    setEmp({
      ...emp,
      image_url: res.data.updatedUser.image_url,
      image_thumbnail_url: res.data.updatedUser.image_thumbnail_url,
    })
  }

  /* Create Employee */
  const handleClickCreate = () => {
    if (isEditPersonal || isEditCompany || isEditRole || isEditMovement) {
      const actions = {
        cancel: closeResponseModal,
        discard: () => {
          Promise.all([
            dispatch(employeeAction.setEditPersonal({ isEditPersonal: false })),
            dispatch(employeeAction.setEditCompany({ isEditCompany: false })),
            dispatch(employeeAction.setEditRole({ isEditRole: false })),
            dispatch(employeeAction.setEditMovement({ isEditMovement: false })),
          ])
          childEditPane.current.resetInvalidList()
          getEmpDataByID(activeItem)
          closeResponseModal()
          setIsCreate(true)
        },
      }
      openDiscardModal(actions)
    } else {
      setIsCreate(true)
    }
  }

  const createEmployee = async payload => {
    setIsCreate(false)
    const _payload = { ...payload }
    _payload.movement_start_date = _payload.start_date
    _payload.movement_name = _payload.name
    _payload.movement_description = _payload.description
    delete _payload.start_date
    delete _payload.name
    delete _payload.description
    delete _payload.hiring_date
    const res = await dispatch(employeeAction.createUser(_payload, access_token))
    if (res && res.payload.createdUser) {
      dispatch(employeeAction.getUser(access_token))
    }
  }

  const handleCreateMovement = async payload => {
    const user_id = payload.user_id
    const _payload = filterMovement(payload)
    _payload.movement_start_date = _payload.start_date
    _payload.movement_name = _payload.name
    _payload.movement_description = _payload.description
    delete _payload.start_date
    delete _payload.name
    delete _payload.description
    delete _payload.email
    const res = await dispatch(employeeAction.createMovement(user_id, _payload, access_token))
    if (res && res.payload.updatedUser) {
      dispatch(employeeAction.getUser(access_token))
      getEmpDataByID(res.payload.updatedUser._id, res.payload.updatedMovement._id)
    }
  }
  /* Create Employee */

  /* Update Employee */
  const handleSavePersonal = async payload => {
    const _payload = filterPersonal(payload)
    await dispatch(employeeAction.editUser(payload._id, _payload, access_token))
    Promise.all([
      dispatch(employeeAction.getUser(access_token)),
      getEmpDataByID(payload._id),
    ])
    dispatch(employeeAction.setEditPersonal({ isEditPersonal: false }))
  }

  const handleSaveMovement = async payload => {
    const movement_id = payload._id
    const _payload = filterMovement(payload)
    _payload.movement_start_date = _payload.start_date
    _payload.movement_name = _payload.name
    _payload.movement_description = _payload.description
    delete _payload.start_date
    delete _payload.name
    delete _payload.description
    delete _payload.email
    delete _payload.hiring_date
    await dispatch(employeeAction.editMovement(movement_id, _payload, access_token))
    Promise.all([
      dispatch(employeeAction.getUser(access_token)),
      getEmpDataByID(payload.user_id),
    ])
    dispatch(employeeAction.setEditMovement({ isEditMovement: false }))
  }

  const handleSavePrivilegeRole = async payload => {
    const _payload = filterRole(payload)
    const res = await dispatch(employeeAction.editPrivilegeRole(payload.user_id, _payload, access_token))
    if (res && res.payload.updatedUserPrivilege) {
      getEmpDataByID(payload.user_id)
    }
    dispatch(employeeAction.setEditRole({ isEditRole: false }))
  }

  const handleSaveCompany = async payload => {
    const _payload = filterPersonal(payload)
    const res = await dispatch(employeeAction.editUser(payload._id, _payload, access_token))
    if (res && res.payload.updatedUser) {
      getEmpDataByID(payload._id)
    }
    dispatch(employeeAction.setEditCompany({ isEditCompany: false }))
  }
  /* Update Employee */

  /* Delete Employee */
  const handleClickDelete = id => {
    const actions = {
      cancel: closeResponseModal,
      delete: () => {
        deleteEmployee(id)
        closeResponseModal()
      },
    }
    dispatch(employeeAction.openResponseModal({
      responseModal: {
        isOpen: true,
        res: {
          title: 'Confirm Delete',
          description: 'This action cannot be undone, are you sure you want to delete?',
          actions: modalButtons('delete', actions),
        },
      },
    }))
  }

  const deleteEmployee = async id => {
    const res = await dispatch(employeeAction.deactivateUser(id, access_token))
    if (res && res.payload.ok) {
      dispatch(employeeAction.getUser(access_token))
    }
    resetEditState()
  }

  const handleDeleteMovement = id => {
    const actions = {
      cancel: closeResponseModal,
      delete: () => {
        deleteMovement(id)
        closeResponseModal()
      },
    }
    dispatch(employeeAction.openResponseModal({
      responseModal: {
        isOpen: true,
        res: {
          title: 'Confirm Delete',
          description: 'This action cannot be undone, are you sure you want to delete?',
          actions: modalButtons('delete', actions),
        },
      },
    }))
  }

  const deleteMovement = async id => {
    const res = await dispatch(employeeAction.deleteMovement(id, access_token))
    if (res && res.payload.updatedUser) {
      getEmpDataByID(res.payload.updatedUser._id, null, true)
      await dispatch(employeeAction.setEditMovement({ isEditMovement: false }))
    }
  }
  /* Delete Employee */

  const closeManual = () => {
    dispatch(employeeAction.closeManual())
  }

  return (
    <Root>
      { isFetching &&
        <Overlay>
          <OverlayWrapper>
            <BeatLoader
              css={ css(`
                position: absolute;
                left: 50%;
                top: 50%;
              `) }
              sizeUnit={ "px" }
              size={ 15 }
              color={ '#D44B49' }
              loading={ isFetching }
            />
          </OverlayWrapper>
        </Overlay>
      }
      <Manual
        isOpen={ isOpenManual }
        closeManual={ closeManual }
      />
      <SimpleModal
        isOpen={ responseModal.isOpen }
        toggle={ closeResponseModal }
        { ...responseModal.res }
      />
      <ActionBar handleClickCreate={ handleClickCreate } />
      { isCreate &&
        <CreateForm
          isCreate={ isCreate }
          setIsCreate={ setIsCreate }
          _companys={ _companys }
          _lobs={ _lobs }
          _positions={ _positions }
          _departments={ _departments }
          _divisions={ _divisions }
          _teams={ _teams }
          employeeList={ employeeList }
          createEmployee={ createEmployee }
        />
      }
      <Wrapper>
        <DataTable
          employeeList={ employeeList }
          activeItem={ activeItem }
          handleClickRow={ handleClickRow }
        />
        <EditPane
          ref={ childEditPane }
          emp={ emp }
          movementData={ movementData }
          movements={ movements }
          _companys={ _companys }
          _lobs={ _lobs }
          _positions={ _positions }
          _departments={ _departments }
          _divisions={ _divisions }
          _teams={ _teams }
          employeeList={ employeeList }
          setEmp={ setEmp }
          setMovementData={ setMovementData }
          openDetail={ openDetail }
          handleClickEditTab={ handleClickEditTab }
          handleSavePersonal={ handleSavePersonal }
          handleSaveCompany={ handleSaveCompany }
          handleSaveMovement={ handleSaveMovement }
          handleSavePrivilegeRole={ handleSavePrivilegeRole }
          handleClickDelete={ handleClickDelete }
          handleClickClose={ handleClickClose }
          handleClickCancel={ handleClickCancel }
          handleUploadImage={ handleUploadImage }
          handleCreateMovement={ handleCreateMovement }
          handleDeleteMovement={ handleDeleteMovement }
        />
      </Wrapper>
    </Root>
  )
}

export default withLayout(UserPage)

const Root = styled.div`
    display: flex;
    flex-direction: column;
`

const Wrapper = styled.div`
    display: flex;
`

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 1;
`

const OverlayWrapper = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
`



// WEBPACK FOOTER //
// ./src/pages/new-employee/index.js